import React from 'react';
import { ProductFormManager } from '../event-fields/ProductFormManager';

/**
 * Event Products Tab — iade ayarları ürün bazlı (her ürünün kendi son tarihi).
 */
export const EventProductsTab = ({ eventType, isEdit = false, record = {} }) => {
  return (
    <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
      <ProductFormManager eventType={eventType} disabled={isEdit} isEdit={isEdit} record={record} />
    </div>
  );
};
